import { Stack } from "@mantine/core";
import { Controller } from "react-hook-form";
import { FormFieldController } from "../../../BuildingBlocks/Forms/Controllers/FormFieldController";
import { CustomFormFieldWrapper } from "../../../BuildingBlocks/Forms/MantineFormFields/CustomFormFieldWrapper/CustomFormFieldWrapper";
import { VollbenutzungsstundenList } from "../../../StromStg/VollbenutzungsstundenList/VollbenutzungsstundenList";
import { GENERATOR_FORM_DATA } from "../GeneratorModal.constants";
import type { GeneratorFormSectionProps } from "../GeneratorModal.types";

function KwkAnlageTab({ generatorForm }: GeneratorFormSectionProps) {
  const { control, watch } = generatorForm;
  const foerderregime = watch("einheit.kwk_anlage.foerderregime");
  const generatorId = watch("id");

  return (
    <Stack gap={0}>
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.im_mastr_registriert"]}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.mastr_nummer"]}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.foerderregime"]}
      />
      <FormFieldController
        control={control}
        data={
          GENERATOR_FORM_DATA["einheit.kwk_anlage.vorrichtungen_abwaermeabfuhr"]
        }
      />
      <FormFieldController
        control={control}
        data={
          GENERATOR_FORM_DATA["einheit.kwk_anlage.elektrische_kwk_leistung"]
        }
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.inbetriebnahmedatum"]}
      />
      <FormFieldController
        control={control}
        data={
          GENERATOR_FORM_DATA[
            "einheit.kwk_anlage.mech_energie_stromerzeugung_paragraph_3_abs_1_nr_1_energiestg"
          ]
        }
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.hocheffizient"]}
      />
      <FormFieldController
        control={control}
        data={
          GENERATOR_FORM_DATA[
            "einheit.kwk_anlage.energiesteuerentlastung_paragraph_53a_energiestg"
          ]
        }
      />
      <FormFieldController
        control={control}
        data={
          GENERATOR_FORM_DATA[
            "einheit.kwk_anlage.energiesteuerentlastung_paragraph_53_energiestg"
          ]
        }
      />
      <FormFieldController
        control={control}
        data={
          GENERATOR_FORM_DATA[
            "einheit.kwk_anlage.steuerbefreiung_strom_zur_stromerz_paragraph_9_abs_2_stromstg"
          ]
        }
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.bafa_anlagennummer"]}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.gesamtwirkungsgrad"]}
      />
      <FormFieldController
        control={control}
        data={GENERATOR_FORM_DATA["einheit.kwk_anlage.nutzungsgrad"]}
      />
      {foerderregime && generatorId && (
        <Controller
          control={control}
          name={
            GENERATOR_FORM_DATA["einheit.kwk_anlage.vollbenutzungsstunden"].name
          }
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <CustomFormFieldWrapper
              {...GENERATOR_FORM_DATA[
                "einheit.kwk_anlage.vollbenutzungsstunden"
              ]}
              error={error?.message}
            >
              <VollbenutzungsstundenList
                foerderregime={foerderregime}
                kwkAnlagenId={generatorId} // we don't know kwkAnlagenId that's why we use generatorId 🤷‍♂️ fabian allendorf might know more
                vollbenutzungsstunden={value || []}
                onInput={(_fieldName, newVBHList) => onChange(newVBHList)}
              />
            </CustomFormFieldWrapper>
          )}
        />
      )}
    </Stack>
  );
}

export { KwkAnlageTab };
